// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viral-clips-dashboard-demo {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.demo-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e3e3e3;
}

.demo-header h1 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1rem;
}

.job-info {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  color: #666;
  font-size: 0.9rem;
}

.job-info span {
  display: inline-block;
  padding: 0.5rem 0.8rem;
  background-color: #f0f0f0;
  border-radius: 4px;
}

/* Loading state */
.viral-clips-dashboard-demo.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.loader {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error state */
.viral-clips-dashboard-demo.error {
  padding: 2rem;
  text-align: center;
  color: #d32f2f;
}

.viral-clips-dashboard-demo.error h2 {
  margin-bottom: 1rem;
  color: #d32f2f;
}

.viral-clips-dashboard-demo.error button {
  margin-top: 1rem;
  padding: 0.6rem 1.2rem;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.viral-clips-dashboard-demo.error button:hover {
  background-color: #1976d2;
}

/* No data message */
.no-data {
  padding: 3rem;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  color: #666;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .viral-clips-dashboard-demo {
    padding: 1.5rem;
  }
  
  .demo-header h1 {
    font-size: 1.8rem;
  }
  
  .job-info {
    flex-direction: column;
    gap: 0.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/ViralClipsDashboardDemo.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":[".viral-clips-dashboard-demo {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.demo-header {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e3e3e3;\n}\n\n.demo-header h1 {\n  font-size: 2.2rem;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.job-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.job-info span {\n  display: inline-block;\n  padding: 0.5rem 0.8rem;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n}\n\n/* Loading state */\n.viral-clips-dashboard-demo.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n}\n\n.loader {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error state */\n.viral-clips-dashboard-demo.error {\n  padding: 2rem;\n  text-align: center;\n  color: #d32f2f;\n}\n\n.viral-clips-dashboard-demo.error h2 {\n  margin-bottom: 1rem;\n  color: #d32f2f;\n}\n\n.viral-clips-dashboard-demo.error button {\n  margin-top: 1rem;\n  padding: 0.6rem 1.2rem;\n  background-color: #2196f3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.viral-clips-dashboard-demo.error button:hover {\n  background-color: #1976d2;\n}\n\n/* No data message */\n.no-data {\n  padding: 3rem;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 8px;\n  color: #666;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .viral-clips-dashboard-demo {\n    padding: 1.5rem;\n  }\n  \n  .demo-header h1 {\n    font-size: 1.8rem;\n  }\n  \n  .job-info {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
